module.exports = __webpack_public_path__ + "img/fibra_optica.ab00c2de.jpg";